export type FilterKeys = 'assets' | 'folders' | 'projects';

export const ALLOWED_FILTER_TOKENS: Set<FilterKeys> = new Set([
  'assets',
  'folders',
  'projects',
]);

export const QUERY_PARAM_KEY = 'query';
export const OBJECT_TYPE_PARAM_KEY = 'object_type';
export const PROJECTS_PARAM_KEY = 'projects';
export const WORKSPACES_PARAM_KEY = 'workspaces';
// @todo (SRCH-2455): Remove after M2 is at 100% and legacy tab URLs are deprecated.
export const TAB_PARAM_KEY = 'tab';
export const MODE_PARAM_KEY = 'mode';
export const HIGHLIGHT_START_PARAM_KEY = 'highlightStart';
export const HIGHLIGHT_END_PARAM_KEY = 'highlightEnd';

export const FILE_TYPE_PARAM_KEY = 'file_type';
export const INCLUDE_PARAM_KEY = 'include';
export const DATE_PARAM_KEY = 'date';
export const SORT_PARAM_KEY = 'sort';

// @todo (SRCH-2455): Rename this tab mapping for mode URLs after rollout; retain the shared mode-to-section conversion.
export const TAB_URL_TO_SECTION_ID: Record<string, 'lexical' | 'nlp'> = {
  standard: 'lexical',
  ai: 'nlp',
};

// @todo (SRCH-2455): Rename this tab mapping for mode URLs after rollout; retain the shared section-to-mode conversion.
export const TAB_SECTION_ID_TO_URL: Record<
  'lexical' | 'nlp',
  'standard' | 'ai'
> = {
  lexical: 'standard',
  nlp: 'ai',
};
